import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import * as actions from './actions';
import { MspAjaxService } from 'projects/angular-clarity/src/app/services/ajax/msp-ajax.service';

@Injectable()
export class CwmConfigEffects {
    load$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actions.loadMspCwmConfig),
            mergeMap(() =>
                this.ajax.get('/api/octiga/v3/msp/cwm/config').pipe(
                    map((data) => actions.loadMspCwmConfigSuccess({ data })),
                    catchError((error) => of(actions.loadMspCwmConfigFailure({ error }))),
                ),
            ),
        ),
    );

    update$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actions.updateMspCwmConfig),
            mergeMap(({ data }) =>
                this.ajax.put('/api/octiga/v3/msp/cwm/config', data).pipe(
                    map(() => actions.updateMspCwmConfigSuccess()),
                    catchError((error) => of(actions.updateMspCwmConfigFailure({ error }))),
                ),
            ),
        ),
    );

    constructor(
        private actions$: Actions,
        private ajax: MspAjaxService,
    ) {}
}
